import { createStructuredSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';

const alertId = (state) => resolveProp('alerts.alertId', state);
const isAlertOpen = (state) => resolveProp('alerts.isAlertOpen', state);
const alertType = (state) => resolveProp('alerts.alertType', state);
const alertContent = (state) => resolveProp('alerts.alertContent', state);
const alertCloseText = (state) => resolveProp('alerts.alertCloseText', state);
const isDismissible = (state) => resolveProp('alerts.isDismissible', state);
const duration = (state) => resolveProp('alerts.duration', state);
const href = (state) => resolveProp('alerts.href', state);
const ctaText = (state) => resolveProp('alerts.ctaText', state);
const title = (state) => resolveProp('alerts.title', state);
const isNewTab = (state) => resolveProp('alerts.isNewTab', state);

export default createStructuredSelector({
    alertId,
    isAlertOpen,
    alertType,
    alertContent,
    alertCloseText,
    isDismissible,
    duration,
    href,
    ctaText,
    title,
    isNewTab,
});
